// src/components/atoms/avatar/Avatar.tsx
import React from 'react';
import GlyphAtom from '../Glyph/GlyphAtom';
import type { GlyphColor } from '../../../types/glyph';
import './sphere-avatar.scss';

interface SphereAvatarProps {
  glyph?: string | null;
  glyphColor?: GlyphColor;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const SphereAvatar: React.FC<SphereAvatarProps> = ({ glyph, glyphColor, size = 'medium', className = '' }) => {
  return (
    <span className={`sphere-avatar-atom ${size} ${className}`}>
      <GlyphAtom glyph={glyph} glyphColor={glyphColor} />
    </span>
  );
};

export default SphereAvatar;
